import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

/** The same saved source is used for the thumbnail and the uncropped preview. */
export function ConceptBoardReferencePreview({ src, label }: { src: string | null | undefined; label: string }) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const unavailable = !src || failedUrl === src;
  return <Dialog>
    <DialogTrigger asChild>
      <button type="button" aria-label={`Preview ${label}`}
        className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200 transition hover:ring-violet-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-600">
        {unavailable
          ? <span role="img" aria-label="Board reference preview unavailable" className="px-1 text-center text-[10px] text-slate-500">Image unavailable</span>
          : <img src={src} alt="Board reference" className="h-full w-full rounded-lg object-cover" onError={() => setFailedUrl(src)} />}
      </button>
    </DialogTrigger>
    <DialogContent className="flex max-h-[92dvh] w-[calc(100%-2rem)] max-w-6xl flex-col overflow-hidden rounded-2xl border-slate-200 bg-[#fffefd] p-4 sm:p-6">
      <DialogHeader className="shrink-0 pr-8 text-left">
        <DialogTitle>Reference preview</DialogTitle>
        <DialogDescription>{label} · Full image</DialogDescription>
      </DialogHeader>
      <div className="flex min-h-0 min-w-0 items-center justify-center rounded-lg bg-slate-100">
        {unavailable
          ? <p role="status" className="px-6 py-16 text-center text-sm text-slate-500">Image unavailable. This reference could not be loaded.</p>
          : <img src={src} alt={`${label} — full image`}
            className="block max-h-[calc(92dvh-8rem)] w-auto max-w-full object-contain"
            onError={() => setFailedUrl(src)} />}
      </div>
    </DialogContent>
  </Dialog>;
}
